import React, {
  useState,
  useEffect,
  useRef,
  FunctionComponent,
} from "react";
import "./Dropdown.scss";
import { Icon, Input, Loader } from "@scuf/common";
import "@scuf/charts/honeywell/theme.css";
import { INPUT_COLOR_DISABLED, ORGANIZATION_SBGGBE_CATEGORY, TRENDS_COLORS } from 'src/constants/constants';
interface childData {
  text: string
  value:string
}
interface menuData {
  parent?: string
  child: childData[]
}
interface IFilterProps {
  selectedData: string
  selectedParentData?:Array<any>
  onFiltersClick: Function;
  label?: string;
  onClickFunction?: Function;
  columDetails?: string;
  dropdownData: Array<menuData>
  isMultiSelectParent?: boolean;
  onChangeParentSelection?: Function;
  disabled?: boolean;
  loader?:boolean
}
const Dropdown: FunctionComponent<IFilterProps> = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOpenArray, setIsOpenArray] = useState([false]);
  const [data, setData] = useState(props.dropdownData);


  const handleToggleSubmenu = (index: number) => {
    let newArr = [...isOpenArray];
    newArr[index] = !newArr[index];
    setIsOpenArray(newArr);
  };

  const dropdDownRef = useRef(null);

  useEffect(() => {
    setData(props.dropdownData);
  }, [props.dropdownData]);


  //Handle outside click, dropdown menu closes
  const useDropdownReference = (ref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsMenuOpen(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useDropdownReference(dropdDownRef)

  const handleSearchInput = (data: string) => {
    let filteredChildList: any = [];
    let filteredArray: any = [];

    if (data.length === 0) {
      setData(props.dropdownData)
    } else {
      props?.dropdownData.map((i: any) => {
        filteredChildList = i.child.filter((u: any) => u.text.toLowerCase().includes(data.toLowerCase()))
        if (filteredChildList.length > 0) {
          filteredArray.push({ ...filteredArray, parent: i.parent, child: filteredChildList })
        }
      });
      setData(filteredArray);
    }
  }

  const handleOnClick = () => {
    if (props.disabled) {
      return;
    }
    props.onClickFunction && props.onClickFunction(props.columDetails); 
    setIsMenuOpen(!isMenuOpen)
  }
  const styles = (): any => props.disabled ? {background: INPUT_COLOR_DISABLED, cursor: 'not-allowed'}: {};
  const handleMultiOptionCheck = (checked: boolean, value: string|any) => {
    let selectedParents: number | string[] = [];
    if(props.selectedParentData && props.selectedParentData.length) {
      selectedParents = [...props.selectedParentData];
    }
    let newselectedParents = checked ? [...selectedParents, value] : selectedParents.filter((data: string)=> data !== value);
    return props.onChangeParentSelection ? props.onChangeParentSelection(newselectedParents): []
  }

 
  return (
    <div className="">
      <div className="dropdown--label">
        {props?.label}
      </div>
      <div ref={dropdDownRef}>
        <div  className={`dropdown--box ${isMenuOpen ? "visible" : ""}`} onClick={() => { handleOnClick() }} style={styles()}>
          <div className="text">
            {props.selectedParentData && props.selectedParentData.length===0 && props.selectedData==='' ? ORGANIZATION_SBGGBE_CATEGORY.RESET_TEXT:(props.isMultiSelectParent ?( props.selectedParentData && props.selectedParentData.length>0 ?  props.selectedParentData +" ": `${props.selectedData.length < 25 ? (props.selectedData)
              : (props.selectedData.substring(0, 25) + "...")}`) : `${props.selectedData.length < 25 ? (props.selectedData)
              : (props.selectedData.substring(0, 25) + "...")}`)}
          </div>
          <Icon
            root="common"
            size="small"
            name={isMenuOpen ? "caret-up" : "caret-down"}
            className="icon"
          ></Icon>
        </div>
        {isMenuOpen && (
          <div className="dropdown">
            <div id="search_input">
              <span>
                <Icon root="common" name="search" size="small" className="search_icon" />
              </span>
              <span>
                <Input
                  placeholder={"Search"}
                  onChange={(data) => { handleSearchInput(data) }}
                />
              </span>
            </div>
            <div>
            {props.loader && <Loader
                className="dropdown__loader"
                minHeight="28vh"
                max-height="70vh"
                overlayColor={TRENDS_COLORS.TRANSPARENT}
              />}
              {
                data?.length > 0 ?
                  data.map((item, idx) => (

                    <div key={idx}>
                      <div
                        className="dropdown__item"
                        onClick={(e) => {
                          handleToggleSubmenu(idx);
                          e.stopPropagation();}
                        }>
                        {props.isMultiSelectParent && 
                          <input 
                            type="checkbox" 
                            checked={props.selectedParentData?.includes(item.parent)} 
                            onClick={(e: any) => {
                              handleMultiOptionCheck(e.target.checked, item.parent);
                              e.stopPropagation();
                            }} 
                          />}
                        <Icon
                          root="common"
                          size="small"
                          name={isOpenArray[idx] ? "caret-down" : "caret-right"}
                          className="icon"
                          onClick={() => handleToggleSubmenu(idx)
                          }
                        ></Icon>
                        <div className="text">{item.parent}</div>
                      </div>
                      {isOpenArray[idx] &&
                        item.child.map((element, key) => (
                          <div className="dropdown__item--list">
                            <div className="text"
                              onClick={() => {
                                props.onFiltersClick && props.onFiltersClick(item.parent, element.text);
                                setIsMenuOpen(!isMenuOpen);
                              }}>
                              <ul><li>{element.text}</li></ul>
                            </div>
                          </div>
                        ))}
                    </div>
                  )) :''
              }
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
